import { Component } from 'react';
import { AssignmentType } from 'models/enum';
import { CaseStudy, SimulationEhr } from 'models/ui';
import { apiHelper } from 'helpers';
import { caseStudyService, simulationService } from 'services';
import { Sidebar } from 'components/common';
import QuickViewPanel, { QuickViewPanelProps } from './QuickViewPanel';
import AssignmentPreview from './assignment-preview/AssignmentPreview';

export enum Tabs {
  OVERVIEW = 0,
  CHARTS_INVOLVED = 1,
  PHASES = 2
}

export interface QuickViewProps {
  initialShowPreview?: boolean;
  selectedContent: CaseStudy | SimulationEhr;
  onCloseSideBar?: VoidFunction;
  onSelectClick?: Function;
  isBookOrganized: boolean;
  assignmentType: string;
}

interface QuickViewStates {
  activeTab: number;
  showPreview: boolean;
  demoContent: CaseStudy | SimulationEhr;
  isDataReady: boolean;
}

class QuickView extends Component<QuickViewProps, QuickViewStates> {
  static displayName = 'QuickView';

  constructor(props) {
    super(props);
    this.state = {
      activeTab: Tabs.OVERVIEW,
      showPreview: props.initialShowPreview || false,
      demoContent: null,
      isDataReady: false
    };
  }

  componentDidUpdate(prevProps) {
    const { selectedContent, assignmentType } = this.props;
    const selectedContentId = selectedContent?.id;

    if (!selectedContentId && prevProps.selectedContent?.id) {
      this.setState({ demoContent: null, isDataReady: false });
      return;
    }

    if (prevProps.selectedContent?.id === selectedContentId && prevProps.assignmentType === assignmentType) {
      return;
    }

    if (selectedContentId) {
      this.setState({ demoContent: null, isDataReady: false });
      const fetchPromise = assignmentType === AssignmentType.CASE_STUDY ? caseStudyService.getCaseStudy(selectedContentId) : simulationService.getSimulation(selectedContentId);

      fetchPromise
        .then(({ data }) => {
          if (this.props.selectedContent?.id === selectedContentId) {
            this.setState({ demoContent: data, isDataReady: true });
          }
        })
        .catch((err) => {
          if (this.props.selectedContent?.id === selectedContentId) {
            this.setState({ demoContent: null, isDataReady: false });
            apiHelper.showApiError(`could not load content details ${err}`);
          }
        });
    }
  }

  handleTabGroupClick = (tabIndex) => this.setState({ activeTab: tabIndex });

  handleCloseSideBar = () => this.setState({ activeTab: Tabs.OVERVIEW, showPreview: false }, this.props.onCloseSideBar);

  handlePreview = () => this.setState({ showPreview: true });

  handleBackToQuickView = () => this.setState({ showPreview: false });

  render() {
    const { showPreview, activeTab, demoContent, isDataReady } = this.state;
    const { selectedContent, onSelectClick } = this.props;
    const quickViewContent = demoContent || selectedContent;
    const quickViewProps: QuickViewPanelProps = {
      activeTab,
      selectedContent: quickViewContent,
      onSelectClick,
      onCloseSideBar: this.handleCloseSideBar,
      onTabGroupClick: this.handleTabGroupClick,
      onPreviewContent: this.handlePreview,
      isBookOrganized: this.props.isBookOrganized,
      assignmentType: this.props.assignmentType
    };
    const previewProps = {
      demoContent,
      onBack: this.handleBackToQuickView,
      assignmentType: this.props.assignmentType
    };

    const previewContent = demoContent ? <AssignmentPreview {...previewProps} /> : null;

    return (
      <Sidebar open={!!selectedContent && isDataReady} onClose={this.handleCloseSideBar} hideCloseButton>
        {showPreview ? previewContent : <QuickViewPanel {...quickViewProps} />}
      </Sidebar>
    );
  }
}

export default QuickView;
